export default __webpack_public_path__ + "static/media/thumbnail.4c32a65b.png";